import { Heart } from "lucide-react";
import { Track } from "@/types";
import { useIsMobile } from "@/hooks/useResponsive";
import { cn } from "@/lib/utils";
import { TrackCoverImage } from "./TrackCoverImage";
import { TrackMetadata } from "./TrackMetadata";
import { SponsorCard } from "./SponsorCard";

interface EnhancedTrackInfoProps {
  track: Track;
  sponsorName?: string | null;
  sponsorUsername?: string | null;
  sponsorAvatar?: string | null;
  liked?: boolean;
  onToggleLike?: () => void;
}

export function EnhancedTrackInfo({
  track,
  sponsorName,
  sponsorUsername,
  sponsorAvatar,
  liked,
  onToggleLike,
}: EnhancedTrackInfoProps) {
  const isMobile = useIsMobile();

  return (
    <div className={cn("space-y-4", isMobile ? "space-y-3" : "space-y-6")}>
      {/* Track Card */}
      <div
        className={cn(
          "flex items-start gap-4",
          isMobile ? "flex-row gap-3" : "flex-col md:flex-row",
          isMobile ? "gap-3" : "gap-6",
        )}
      >
        {/* Cover Image */}
        <TrackCoverImage track={track} />

        {/* Track Details */}
        <TrackMetadata track={track} />

        {/* Like button (mobile only — desktop volume row has no room here) */}
        {isMobile && onToggleLike && (
          <button
            onClick={onToggleLike}
            className="flex-shrink-0 p-2 -mr-2 mt-1"
            title={liked ? "Unlike" : "Like"}
          >
            <Heart
              className={cn(
                "h-5 w-5",
                liked ? "fill-red-500 text-red-500" : "text-[#9A96C4]",
              )}
            />
          </button>
        )}
      </div>

      {/* Sponsor Card - Now positioned under track details */}
      {track.isSponsored && sponsorName && (
        <SponsorCard
          sponsorName={sponsorName}
          sponsorUsername={sponsorUsername}
          sponsorAvatar={sponsorAvatar}
        />
      )}
    </div>
  );
}
